import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { BrandMark } from '@/components/BrandMark';
import { GlassButton } from '@/components/GlassButton';

const NAV = [
  { to: '/', label: '首页', end: true },
  { to: '/pricing', label: '会员计划' },
  { to: '/about', label: '关于我们' },
];

export function MarketingShell(): JSX.Element {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = (): void => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return (): void => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-ink-950 text-cream-100">
      <header
        className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-ink-950/85 backdrop-blur-xl border-b border-white/[0.06]'
            : 'bg-ink-950/40 backdrop-blur'
        }`}
      >
        <div className="max-w-6xl mx-auto px-5 md:px-8 h-16 flex items-center gap-4">
          <Link to="/" aria-label="速通英语" className="group">
            <BrandMark size="md" />
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-6">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm transition-colors rounded-lg ${
                    isActive
                      ? 'text-white bg-white/[0.06]'
                      : 'text-cream-300 hover:text-white hover:bg-white/[0.04]'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <GlassButton to="/login" size="sm" variant="ghost">
              登录
            </GlassButton>
            <GlassButton to="/app" size="sm" variant="solid">
              立即使用 →
            </GlassButton>
          </div>
        </div>
      </header>

      <main className="pt-16">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}

function Footer(): JSX.Element {
  return (
    <footer className="border-t border-white/[0.06] mt-24">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-12 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <BrandMark size="md" />
          <p className="mt-4 text-sm text-cream-400 max-w-sm leading-relaxed">
            速通英语 · 像速通游戏一样过英语。Combo · Perfect · 每天 15 分钟，过一局就有进步。
          </p>
        </div>
        <div>
          <div className="text-sm font-semibold text-white mb-3">产品</div>
          <ul className="space-y-2 text-sm text-cream-400">
            <li><Link to="/app/courses" className="hover:text-white">课程市场</Link></li>
            <li><Link to="/app/vocab" className="hover:text-white">单词记忆</Link></li>
            <li><Link to="/pricing" className="hover:text-white">会员计划</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-white mb-3">公司</div>
          <ul className="space-y-2 text-sm text-cream-400">
            <li><Link to="/about" className="hover:text-white">关于我们</Link></li>
            <li><a href="#" className="hover:text-white">用户协议</a></li>
            <li><a href="#" className="hover:text-white">隐私政策</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/[0.06] py-6">
        <div className="max-w-6xl mx-auto px-5 md:px-8 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream-400">
          <div>© 2026 速通 · SpeedRun English</div>
          <div className="opacity-70">苏ICP备15052243号-25 · Re-imagined by Claude</div>
        </div>
      </div>
    </footer>
  );
}
